import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Sun, CheckCircle, Bookmark } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NAV_ITEMS = [
  { to: '/dashboard', icon: LayoutDashboard, labelKey: 'nav.dashboard' },
  { to: '/my-day', icon: Sun, labelKey: 'nav.myDay' },
  { to: '/my-tasks', icon: CheckCircle, labelKey: 'nav.myTasks' },
  { to: '/bookmarks', icon: Bookmark, labelKey: 'nav.bookmarks' },
];

export function BottomNav() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-default z-40 safe-area-pb">
      <div className="flex justify-around">
        {NAV_ITEMS.map(({ to, icon: Icon, labelKey }) => {
          const active = location.pathname === to;
          return (
            <Link
              key={to}
              to={to}
              className={`flex flex-col items-center py-2 px-3 min-w-[64px] transition-colors ${
                active ? 'text-accent' : 'text-muted'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] mt-0.5">{t(labelKey)}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
